import { render, staticRenderFns } from "./dcs.vue?vue&type=template&id=105c0325&scoped=true&"
import script from "./dcs.vue?vue&type=script&lang=js&"
export * from "./dcs.vue?vue&type=script&lang=js&"
import style0 from "./dcs.vue?vue&type=style&index=0&id=105c0325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105c0325",
  null
  
)

export default component.exports